import React from "react";
import { motion } from "framer-motion";

const Modal = ({ onClick, children }) => {
  return (
    <motion.div
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.3, ease: "easeIn" }}
      exit={{ opacity: 0.5, transition: { duration: 0.5, ease: "easeOut" } }}
      className="flex flex-col items-center justify-center w-full h-full"
    >
      <div
        onClick={onClick}
        className="fixed left-0 top-0 bottom-0 z-50 w-full h-full bg-[#272727] opacity-30"
      ></div>

      <div className="fixed top-5 flex items-center justify-center w-[90%] h-full z-50 lg:left-[10%] lg:w-[80%] lg:top-16 xl:left-[19.5%] xl:top-[70px] xl:w-[63%] 2xl:left-[21%] 2xl:w-[55%]">
        {children}
      </div>
    </motion.div>
  );
};

export default Modal;
